import { InstructorsGroupLesson } from './';

export default class InstructorsBundlesGroupsLessons {
    BundleId: number = 0;
    MinDate?: string;
    MaxDate?: string;
    Lessons: Array<InstructorsGroupLesson> = [];
}